var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import { mixpanelTracking } from '@/services/mixpanel';
import { getHubspotToken } from '@/clients/crm';
let HubSpotCallback = class HubSpotCallback extends Vue {
    constructor() {
        super(...arguments);
        this.code = '';
        this.waiting = true;
    }
    async mounted() {
        //@ts-ignore
        this.code = decodeURI(this.$route.query.code);
        try {
            const redirect_uri = window.location.origin + window.location.pathname;
            await getHubspotToken({
                code: this.code,
                redirect_uri,
            });
            mixpanelTracking('integrações: Integrado com Hubspot');
            this.waiting = false;
        }
        catch (e) {
            console.log(e);
        }
    }
};
HubSpotCallback = __decorate([
    Component({
        name: 'HubSpotCallback',
    })
], HubSpotCallback);
export default HubSpotCallback;
